import { render, staticRenderFns } from "./NoxSendCriteria.vue?vue&type=template&id=491e41f4&scoped=true"
import script from "./NoxSendCriteria.vue?vue&type=script&lang=js"
export * from "./NoxSendCriteria.vue?vue&type=script&lang=js"
import style0 from "./NoxSendCriteria.vue?vue&type=style&index=0&id=491e41f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491e41f4",
  null
  
)

export default component.exports